export const EVENT_COLORS = {
  SEVERITY: {
    CRITICAL: "#ff9aa2",
    MAJOR: "#ffdac1",
    MINOR: "#e2f0cb",
    AUDIT: "#b5ead7",
    INFORMATIONAL: "#c7ceea",
  },
  ACTION: {
    ALLOWED: "#90ed7d",
    BLOCKED: "#fd7f6f",
  },
  FEATURE: {
    IPS: "#7cb5ec",
    ANTIVIRUS: "#434348",
    DLP: "#90ed7d",
    ANOMALY: "#f7a35c",
    APPS: '#bd7ebe',
    WEBFILTER: '#ffee65',
  },
  BRIGHTCLOUD_ID: {
    "UNCATEGORIZED": "#FD7F6F",
    "REAL ESTATE": "#90ED7D",
    "COMPUTER AND INTERNET SECURITY": "#7CB5EC",
    "FINANCIAL SERVICES": "#BD7EBE",
    "BUSINESS AND ECONOMY": "#F7A35C",
    "COMPUTER AND INTERNET INFO": "#FFEE65",
    "AUCTIONS": "#BEB9DB",
    "SHOPPING": "#FDCCE5",
    "CULT AND OCCULT": "#8BD3C7",
    "TRAVEL": "#B3D4FF",
    "ABUSED DRUGS": "#FFB347",
    "ADULT AND PORNOGRAPHY": "#98FB98",
    "HOME AND GARDEN": "#00FF7F",
    "MILITARY": "#87CEFA",
    "SOCIAL NETWORKING": "#FFDAB9",
    "DEAD SITES": "#DD969C",
    "INDIVIDUAL STOCK ADVICE AND TOOLS": "#AEC6cf",
    "TRAINING AND TOOLS": "#B0E0E6",
    "DATING": "#FDFD96",
    "SEX EDUCATION": "#B19CD9",
    "RELIGION": "#ADD8E6",
    "ENTERTAINMENT AND ARTS": "#E75480",
    "PERSONAL SITES AND BLOGS": "#C8C8A9",
    "LEGAL": "#D8BFD8",
    "LOCAL INFORMATION": "#E0E0EB",
    "STREAMING MEDIA": "#E6E6FA",
    "JOB SEARCH": "#F5F5DC",
    "GAMBLING": "#B0C4DE",
    "TRANSLATION": "#FFAEB9",
    "REFERENCE AND RESEARCH": "#AFEEEE",
    "SHAREWARE AND FREEWARE": "#87CEEB",
    "PEER TO PEER": "#FF7F50",
    "MARIJUANA": "#FF9AA2",
    "HACKING": "#FFDAC1",
    "GAMES": "#E2F0CB",
    "PHILOSOPHY AND POLITICAL ADVOCACY": "#FFC300",
    "WEAPONS": "#F7DC6F",
    "PAY TO SURF": "#BE2121",
    "HUNTING AND FISHING": "#DAA520",
    "SOCIETY": "#1ABC9C",
    "EDUCATIONAL INSTITUTIONS": "#FFFEB7",
    "ONLINE GREETING CARDS": "#3498DB",
    "SPORTS": "#2980B9",
    "SWIMSUITS AND INTIMATE APPAREL": "#9B59B6",
    "QUESTIONABLE": "#8E44AD",
    "KIDS": "#FF69B4",
    "HATE AND RACISM": "#F39C12",
    "PERSONAL STORAGE": "#E67E22",
    "VIOLENCE": "#E74C3C",
    "KEYLOGGERS AND MONITORING": "#C0392B",
    "SEARCH ENGINES": "#ECF0F1",
    "INTERNET PORTALS": "#BDC3C7",
    "WEB ADVERTISEMENTS": "#7F8C8D",
    "CHEATING": "#2C3E50",
    "GROSS": "#34495E",
    "WEB - BASED EMAIL": "#16A085",
    "MALWARE SITES": "#27AE60",
    "PHISHING AND OTHER FRAUDS": "#95A5A6",
    "PROXY AVOIDANCE AND ANONYMIZERS": "#00FFFf",
    "SPYWARE AND ADWARE": "#800080",
    "MUSIC": "#FFA500",
    "GOVERNMENT": "#008080",
    "NUDITY": "#000000",
    "NEWS AND MEDIA": "#FF00FF",
    "ILLEGAL": "#FFC0CB",
    "CONTENT DELIVERY NETWORKS": "#FFA07A",
    "INTERNET COMMUNICATIONS": "#DC143C",
    "BOT NETS": "#FF1493",
    "ABORTION": "#FFB6C1",
    "HEALTH AND MEDICINE": "#F08080",
    "CONFIRMED SPAM SOURCES": "#FFD700",
    "SPAM URLS": "#808000",
    "UNCONFIRMED SPAM SOURCES": "#8B008B",
    "OPEN HTTP PROXIES": "#800000",
    "DYNAMICALLY GENERATED CONTENT": "#7CFC00",
    "PARKED DOMAINS": "#00FF00",
    "ALCOHOL AND TOBACCO": "#4682B4",
    "PRIVATE IP ADDRESSES": "#FF8C00",
    "IMAGE AND VIDEO SEARCH": "#1C1C1C",
    "FASHION AND BEAUTY": "#4A4A4A",
    "RECREATION AND HOBBIES": "#555555",
    "MOTOR VEHICLES": "#C0C0C0",
    "WEB HOSTING": "#D35400",
    "FOOD AND DINING": "#8B4513",
    "SELF HARM": "#5B6AA9",
    "DNS OVER HTTPS": "#A95B87",
    "LOW-THC CANNABIS PRODUCTS": "#A6A95B",
    "GENERATIVE AI": "#5BA96F",
  },
  BRIGHTCLOUD_DEFAULT: [
    "#9acad6", "#e4ff50", "#856348", "#cd7193", "#8da2d1",
    "#dde6ad", "#54e7b9", "#ac7171", "#9eb494", "#f04a69",
    "#9ecf31", "#d38bcd", "#ffe4fd", "#6466e0", "#f0f4c2",
    "#ff7b4f", "#a499f0", "#9ef1cd", "#de9494", "#eef75c",
    "#fae6f3", "#dcddf5", "#6765ff", "#e7b16f", "#ffb3c5",
    "#eec5a4", "#52a262", "#8b83b5", "#a85994", "#a85994",
    "#a87e75", "#93ad90", "#b9dbc5", "#deb0c7", "#c1ffc5",
  ],
  DEFAULT: [
    "#fd7f6f", "#7cb5ec", "#90ed7d", "#bd7ebe", "#f7a35c",
    "#ffee65", "#beb9db", "#fdcce5", "#8bd3c7", "#b3d4ff",
    "#ffb347", "#98fb98", "#e0e0eb", "#87cefa", "#ffdab9",
    "#dd969c", "#aec6cf", "#b0e0e6", "#fdfd96", "#b19cd9",
    "#add8e6", "#e75480", "#c8c8a9", "#d8bfd8", "#ffe5b4",
    "#e6e6fa", "#f5f5dc", "#b0c4de", "#ffaeb9", "#afeeee",
    "#87ceeb", "#ff7f50", "#ff9aa2", "#ffdac1", "#e2f0cb",
  ],
};

export const EVENT_TRANSLATIONS = {
  BRIGHTCLOUD_ID: {
    0: "Uncategorized",
    1: "Real Estate",
    2: "Computer and Internet Security",
    3: "Financial Services",
    4: "Business and Economy",
    5: "Computer and Internet Info",
    6: "Auctions",
    7: "Shopping",
    8: "Cult and Occult",
    9: "Travel",
    10: "Abused Drugs",
    11: "Adult and Pornography",
    12: "Home and Garden",
    13: "Military",
    14: "Social Networking",
    15: "Dead Sites",
    16: "Individual Stock Advice and Tools",
    17: "Training and Tools",
    18: "Dating",
    19: "Sex Education",
    20: "Religion",
    21: "Entertainment and Arts",
    22: "Personal sites and Blogs",
    23: "Legal",
    24: "Local Information",
    25: "Streaming Media",
    26: "Job Search",
    27: "Gambling",
    28: "Translation",
    29: "Reference and Research",
    30: "Shareware and Freeware",
    31: "Peer to Peer",
    32: "Marijuana",
    33: "Hacking",
    34: "Games",
    35: "Philosophy and Political Advocacy",
    36: "Weapons",
    37: "Pay to Surf",
    38: "Hunting and Fishing",
    39: "Society",
    40: "Educational Institutions",
    41: "Online Greeting Cards",
    42: "Sports",
    43: "Swimsuits and Intimate Apparel",
    44: "Questionable",
    45: "Kids",
    46: "Hate and Racism",
    47: "Personal Storage",
    48: "Violence",
    49: "Keyloggers and Monitoring",
    50: "Search Engines",
    51: "Internet Portals",
    52: "Web Advertisements",
    53: "Cheating",
    54: "Gross",
    55: "Web - based Email",
    56: "Malware Sites",
    57: "Phishing and Other Frauds",
    58: "Proxy Avoidance and Anonymizers",
    59: "Spyware and Adware",
    60: "Music",
    61: "Government",
    62: "Nudity",
    63: "News and Media",
    64: "Illegal",
    65: "Content Delivery Networks",
    66: "Internet Communications",
    67: "Bot Nets",
    68: "Abortion",
    69: "Health and Medicine",
    70: "Confirmed SPAM Sources",
    71: "SPAM URLS",
    72: "Unconfirmed SPAM Sources",
    73: "Open HTTP Proxies",
    74: "Dynamically Generated Content",
    75: "Parked Domains",
    76: "Alcohol and Tobacco",
    77: "Private IP Addresses",
    78: "Image and Video Search",
    79: "Fashion and Beauty",
    80: "Recreation and Hobbies",
    81: "Motor Vehicles",
    82: "Web Hosting",
    83: "Food and Dining",
    85: "Self Harm",
    86: "DNS Over HTTPS",
    87: "Low-THC Cannabis Products",
    88: "Generative AI",
  },
};

export function getEventColor (key, subkey, index = 0) {
  let color;

  if (key in EVENT_COLORS && subkey in EVENT_COLORS[key]) {
    color = EVENT_COLORS[key][subkey];
  } else if (key === "BRIGHTCLOUD_ID" && subkey > 200) {
    color = EVENT_COLORS.BRIGHTCLOUD_DEFAULT[index];
  } else if (index < EVENT_COLORS.DEFAULT.length) {
    color = EVENT_COLORS.DEFAULT[index];
  } else {
    color = EVENT_COLORS.DEFAULT[0];
  }

  return color;
};

export function getEventName (label, id) {
  if (label) {
    const key = label.toUpperCase();

    if (key in EVENT_TRANSLATIONS) {
      if (id in EVENT_TRANSLATIONS[key]) {
        return EVENT_TRANSLATIONS[key][id];
      } else if (key === "BRIGHTCLOUD_ID" && id > 200) {
        return "Custom Category";
      }
    }
  }

  return id;
};

export function getEventId(label, name) {
  if (label) {
    const key = label.toUpperCase();

    if (key in EVENT_TRANSLATIONS) {
      for (let index in EVENT_TRANSLATIONS[key]) {
        if (EVENT_TRANSLATIONS[key][index] === name) {
          return index;
        }
      }
    }
  }

  return name;
};